import { Grid } from "@mui/material";
import React, { useState } from "react";
import { AuthContext } from "../../components/auth/AuthContext";
import DatePickerComponent from "../../components/date-picker/date-picker";
import Filters from "../../components/filters/index.js";
import Loader from "../../components/loader/index.jsx";
import { useThemeMode } from "../../components/theme/index.jsx";
import { CONVERSATION_BOOKMARKS_API } from "../../helpers/api-path.js";
import Utils from "../../utils.js";
import AgentAnalytics from "./home-agent-analystics.js";
import ComplianceCard from "./home-compliance-card.js";
import PlaylistsCard from "./home-playlist-card.js";
import SentimentChart from "./home-sentiment-chart";
import TopAlertsCard from "./home-top-alerts-card.js";
import TopQuestionsCard from "./home-top-questions.js";
import TopTrackersCard from "./home-top-trackers-card.js";
import TopicSentimentChart from "./home-topic-sentiment-chart";
import VocalysdScore from "./home-vocalysd-score.js";
import TalkRatioCard from "./homr-talk-ratio-card.js";

let senti = [];

function capcase(input) {
    return input.charAt(0).toUpperCase() + input.slice(1);
}

function Home() {
    // const [isDatePickerVisible, setIsDatePickerVisible] = useState(false);
    const { currentNonAdminGroup, isAuthenticated, isAdmin } =
        React.useContext(AuthContext);
    const [data, setData] = React.useState({});
    const [pldata, setPLData] = React.useState([]);
    const [sentiment, setSentiment] = React.useState([]);
    const [topicdata, settopicdata] = React.useState([]);
    const [listofagents, setListofagents] = React.useState([]);
    const [allscore, setAllscore] = React.useState(0);
    const [spinner, setSpinner] = React.useState(false);
    const [pickedAgent, setPickedAgent] = React.useState(true);
    const [pickedAgentTOP, setPickedAgentTOP] = React.useState(true);
    const { colours, themeMode, FONT } = useThemeMode();
    const [loadingAgents, setLoadingAgents] = useState(true);

    var formatedFromDate;
    var formatedToDate;
    var dateFlag = false;
    const checkRange = (sentiments, fromDate, toDate) => {
        let sentimentMonths = [];

        if (dateFlag) {
            sentiments.forEach((sentiment) => {
                const sentimentMonth = sentiment.month; // Assuming month is in 'YYYY-MM' format

                // Compare the sentiment month with fromDate and toDate
                if (sentimentMonth >= fromDate || sentimentMonth <= toDate) {
                    sentimentMonths.push(sentiment); // Add the sentiment to the result if it falls within the range
                }
            });
        } else {
            sentiments.forEach((sentiment) => {
                sentimentMonths.push(sentiment); // Add the sentiment to the result if it falls within the range
            });
        }

        return sentimentMonths; // Return the filtered sentiments
    };

    async function getCampaignData() {
        Utils.sendProgressBar(true);
        setSpinner(true);
        console.log("currentNonAdminGroup", currentNonAdminGroup);
        try {
            let companyData = await Utils.genericList("listCompanies", {
                filter: { internalname: { eq: currentNonAdminGroup } },
            });

            let company = companyData.data?.listCompanies?.items[0]?.id;
            let companyGet = await Utils.genericGet("getCompany", company);
            let s = companyGet.data.getCompany;

            // if (s.VShits === null) {
            //   return;
            // }

            try {
                s.VShits = JSON.parse(s.VShits);
                let score = s.VShits.VS / s.VShits.n;
                setAllscore(score);
            } catch (error) {
                console.error("Error parsing VShits or calculating score:", error);
            }

            s.agenthits = JSON.parse(s.agenthits);
            s.alerthits = JSON.parse(s.alerthits);
            s.durationhits = JSON.parse(s.durationhits);
            s.topichits = JSON.parse(s.topichits);

            // if (s.topichits === null) {
            //   return;
            // }

            let newtopicdata = s.topichits
                .map((ss) => ({
                    keyword: capcase(ss.topic) || capcase(ss.alert),
                    x: 10,
                    y: 10,
                    z: ss.n,
                    sen: ss.s === "pos" ? "pos" : ss.s === "neg" ? "neg" : "neu",
                }))
                .filter((z) => z.z > 10 && z.sen !== "neu")
                .slice(0, 10);

            // Predefined coordinates for up to 10 items
            const coordinates = [
                { x: 10, y: 10 },
                { x: 12.5, y: 11 },
                { x: 10, y: 17 },
                { x: 15, y: 12 },
                { x: 7, y: 16 },
                { x: 18, y: 12 },
                { x: 6, y: 5 },
                { x: 12, y: 5 },
                { x: 13, y: 18 },
                { x: 4, y: 9 },
            ];

            // Assign predefined coordinates to `newtopicdata` items
            newtopicdata = newtopicdata.map((item, index) => ({
                ...item,
                x: coordinates[index]?.x || 10, // Fallback to 10 if index exceeds predefined coordinates
                y: coordinates[index]?.y || 10, // Fallback to 10 if index exceeds predefined coordinates
            }));

            settopicdata(newtopicdata);
            // Parse the JSON objects
            if (s && typeof s === "object") {
                ["sentimenthits", "trackerhits", "questionhits", "analyticshits"].forEach(
                    (key) => {
                        if (s[key]) {
                            s[key] = JSON.parse(s[key]);
                        }
                    }
                );
            } else {
                console.error("s is undefined or not an object:", s);
            }

            // Helper function to calculate sentiment percentages
            const calculateSentiment = (values) => {
                const total = values.neg + values.pos + values.neu;
                if (total === 0) return { Negative: 0, Positive: 0, Neutral: 0 }; // Prevent division by zero
                return {
                    Negative: (values.neg / total) * 100,
                    Positive: (values.pos / total) * 100,
                    Neutral: (values.neu / total) * 100,
                };
            };

            // Function to get sentiment data for a given month
            const getSentimentData = (hits) => {
                console.log(hits);
                // Filter hits to only include months within the specified date range
                const valuesInRange = checkRange(hits, formatedFromDate, formatedToDate);

                if (valuesInRange.length === 0) return null; // If no values found, return null

                // Map over the filtered array to calculate sentiment for each month

                const sentiment = valuesInRange.map((value) => ({
                    name: value.month,
                    ...calculateSentiment(value.values),
                }));

                return sentiment; // Return the array of sentiment data
            };

            // Collect sentiment data for today, last 30 days, and last 60 days
            // senti.push(getSentimentData(s.sentimenthits, today));
            senti = getSentimentData(s.sentimenthits);

            if (senti === null) return null;

            setSentiment(senti);

            setData(s);
            setSpinner(false);
        } catch (error) {
            setSpinner(false);
            console.log("get:ERROR = ", error)
        }

        async function fetchBookmarkedConversations() {
            try {
                const response = await fetch(process.env.REACT_APP_API_BASE_URL + CONVERSATION_BOOKMARKS_API,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            group: currentNonAdminGroup,
                        }),
                    }
                );

                if (!response.ok) {
                    console.error(
                        "Failed to fetch bookmarked conversations:",
                        response.statusText
                    );
                    return [];
                }

                console.log("Successfully fetched bookmarked conversations");

                const data = await response.json();
                const bookmarkedConversations = data.body.conversations || [];
                return bookmarkedConversations;
            } catch (error) {
                console.error("Error fetching bookmarked conversations:", error);
                return [];
            }
        }

        let pl = [];
        let nextToken = null;

        do {
            const response = await Utils.genericListMOD2(
                "listConversations",
                {
                    filter: { bookmarks: { attributeExists: true } },
                    limit: 1000,
                    nextToken: nextToken, // Pass the token to continue from the last result
                },
                true
            );

            if (response?.data?.listConversations?.items) {
                pl = pl.concat(response.data.listConversations.items); // Append the items
            }

            nextToken = response?.data?.listConversations?.nextToken; // Update the token for the next iteration
        } while (nextToken);
        setPLData(pl);
    }

    const getAgentAnalytics = async () => {
        let conversationAgentScore = await Utils.genericListMOD3(null);
        let nt = conversationAgentScore.data.listConversations.nextToken;

        while (nt !== null) {
            let nextLoad = await Utils.genericListMOD3(nt);
            nt = nextLoad.data.listConversations.nextToken;
            conversationAgentScore.data.listConversations.items =
                conversationAgentScore.data.listConversations.items.concat(nextLoad.data.listConversations.items);
        }

        conversationAgentScore = conversationAgentScore.data.listConversations;
        conversationAgentScore = conversationAgentScore.items.filter((z) => z.VS !== null);
        let agentsList = [];
        conversationAgentScore.forEach((z) => {
            let found = agentsList.find((a) => a.agent === z.agent);
            if (found) {
                found.VS += parseInt(z.VS);
                found.n += 1;
            } else {
                agentsList.push({ agent: z.agent, n: 1, VS: parseInt(z.VS) });
            }
        });

        setListofagents(agentsList.map((z) => ({ agent: z.agent, VS: z.VS / z.n })));
        setLoadingAgents(false);
    }

    React.useEffect(() => {
        getCampaignData();
        getAgentAnalytics();
        window.scrollTo(0, 0); // Scroll to top when component mounts
    }, [currentNonAdminGroup, isAuthenticated]);

    const sentimentData = sentiment;
    sentimentData.map((senti, i) => {
        if (senti != null) {
            const d = new Date(senti.name);
            const formattedDate = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
            sentimentData[i].name = formattedDate;
        }
    });

    return (
        <React.Fragment>
            {spinner && <Loader />}
            <Grid
                className="vocalysed-home-upadted analytics"
                container
                spacing={0}
                direction="row"
                flexGrow={1}
                padding={3}
                gap={3}
                overflow="auto"
            >
                <Grid item xs={12} lg sx={{ minWidth: "1px" }} display="flex" flexDirection="column" gap={3}>
                    <SentimentChart
                        sentimentData={sentimentData}
                    />
                    <TopicSentimentChart topicdata={topicdata} colours={colours} />
                    <AgentAnalytics
                        loading={loadingAgents}
                        pickedAgentTOP={pickedAgentTOP}
                        setPickedAgentTOP={setPickedAgentTOP}
                        colours={colours}
                        listOfAgents={listofagents}
                        themeMode={themeMode}
                    />
                </Grid>
                <Grid item xs={12} lg sx={{ minWidth: "1px" }} display="flex" flexDirection="column" gap={3}>
                    <VocalysdScore allscore={allscore} colours={colours} FONT={FONT} />
                    <Grid
                        container
                        flexWrap={{ sm: "nowrap" }}
                        justifyContent="space-between"
                        gap={3}
                    >
                        <ComplianceCard data={data} colours={colours} FONT={FONT} />
                        <TopTrackersCard data={data} colours={colours} />
                    </Grid>
                    <PlaylistsCard pldata={pldata} colours={colours} FONT={FONT} />
                    <Grid
                        container
                        flexWrap={{ sm: "nowrap" }}
                        justifyContent="space-between"
                        gap={3}
                    >
                        <TalkRatioCard data={data} colours={colours} FONT={FONT} />
                        <TopAlertsCard data={data} colours={colours} />
                    </Grid>
                    <TopQuestionsCard
                        data={data}
                        pickedAgent={pickedAgent}
                        setPickedAgent={setPickedAgent}
                        colours={colours}
                        themeMode={themeMode}
                    />
                    {/* {
                        <div
                        style={{
                            position: "fixed",
                            top: 0,
                            right: 0,
                            height: "100vh",
                            width: "300px",
                            transform: isDatePickerVisible
                            ? "translateX(0)"
                            : "translateX(100%)",
                            transition: "transform 0.3s ease-in-out",
                            boxShadow: isDatePickerVisible
                            ? "0px 0px 10px rgba(0,0,0,0.3)"
                            : "none",
                            backgroundColor: "#fff",
                            zIndex: 1000,
                        }}
                        >
                        <DatePickerComponent />
                        </div>
                    } */}
                </Grid>
                <Filters />
            </Grid>
        </React.Fragment>
    );
}

export default Home;